import { TELEGRAM_BOT_URL } from '@/lib/constants'

export function Nav() {
  return (
    <header className="sticky top-0 z-20 backdrop-blur bg-bg/80 border-b border-border">
      <div className="max-w-5xl mx-auto px-5 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <img src="/logo-96.png" alt="John Anthony" className="h-8 w-8 rounded-lg" />
          <span className="font-display text-lg font-bold tracking-tight">
            JOHN <span className="text-brand">ANTHONY</span>
          </span>
        </div>
        <a
          href={TELEGRAM_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg bg-brand text-black text-sm font-semibold hover:brightness-110 transition"
        >
          Probar gratis
        </a>
      </div>
    </header>
  )
}
